import type { NotificationCampaign } from "@/lib/api";

export const NOTIFICATION_POLL_INTERVAL_MS = 5_000;
export const NOTIFICATION_STALL_TIMEOUT_MS = 120_000;
const POLLING_STATUSES = new Set(["pending", "processing"]);

export function isNotificationProcessing(notification: NotificationCampaign): boolean {
  return POLLING_STATUSES.has(notification.status);
}

export function notificationProcessingElapsedMs(notification: NotificationCampaign): number {
  const reference = notification.startedAt ?? notification.updatedAt;
  const timestamp = Date.parse(reference);
  if (Number.isNaN(timestamp)) return 0;
  return Date.now() - timestamp;
}

export function isNotificationStalled(notification: NotificationCampaign): boolean {
  return (
    isNotificationProcessing(notification) &&
    notificationProcessingElapsedMs(notification) >= NOTIFICATION_STALL_TIMEOUT_MS
  );
}

/** Whether the list should keep polling: at least one job is processing and not yet stalled. */
export function hasActivePolling(items: NotificationCampaign[] | undefined): boolean {
  if (!items) return false;
  return items.some((n) => isNotificationProcessing(n) && !isNotificationStalled(n));
}
